module.exports = __webpack_public_path__ + "static/img/5.692d5ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/5.png
// module id = Mv/e
// module chunks = 0